import { useEffect, useState } from 'react';
import { CheckCircle2, PartyPopper, Sparkles } from 'lucide-react';

export default function PaymentSuccessAnimation({ onComplete, message = "Pagamento Confirmado!" }) {
  const [stage, setStage] = useState(0);

  useEffect(() => {
    // Animação em estágios
    const timers = [
      setTimeout(() => setStage(1), 100),
      setTimeout(() => setStage(2), 600),
      setTimeout(() => setStage(3), 1200),
      setTimeout(() => {
        if (onComplete) onComplete();
      }, 3000)
    ];

    return () => timers.forEach(clearTimeout);
  }, [onComplete]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/95 backdrop-blur-sm">
      {/* Confetti effect */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="absolute animate-bounce"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 2}s`,
              animationDuration: `${1 + Math.random() * 2}s`
            }}
          >
            <Sparkles 
              className={`w-4 h-4 ${
                ['text-green-500', 'text-yellow-500', 'text-blue-500', 'text-purple-500', 'text-pink-500'][i % 5]
              }`} 
            />
          </div>
        ))}
      </div>

      <div className="text-center space-y-6 p-8">
        {/* Círculo animado */}
        <div className={`relative mx-auto transition-all duration-500 ${stage >= 1 ? 'scale-100' : 'scale-0'}`}>
          <div className={`w-32 h-32 rounded-full bg-green-500/20 flex items-center justify-center mx-auto
            ${stage >= 1 ? 'animate-pulse' : ''}`}>
            <div className={`w-24 h-24 rounded-full bg-green-500/40 flex items-center justify-center
              transition-all duration-300 ${stage >= 1 ? 'scale-100' : 'scale-0'}`}>
              <CheckCircle2 
                className={`w-16 h-16 text-green-500 transition-all duration-500
                  ${stage >= 2 ? 'scale-100 opacity-100' : 'scale-0 opacity-0'}`}
              />
            </div>
          </div>
          
          {/* Anel pulsante */}
          <div className={`absolute inset-0 rounded-full border-4 border-green-500/50 
            ${stage >= 2 ? 'animate-ping' : 'opacity-0'}`} 
            style={{ animationDuration: '1.5s' }}
          />
        </div>

        {/* Texto */}
        <div className={`space-y-2 transition-all duration-500 ${stage >= 2 ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          <h2 className="text-3xl font-bold text-green-500 flex items-center justify-center gap-2">
            <PartyPopper className="w-8 h-8" />
            {message}
            <PartyPopper className="w-8 h-8 transform scale-x-[-1]" />
          </h2>
          <p className="text-muted-foreground">Seus créditos foram adicionados à sua conta</p>
        </div>

        {/* Barra de progresso */}
        <div className={`w-64 mx-auto transition-all duration-500 ${stage >= 3 ? 'opacity-100' : 'opacity-0'}`}>
          <div className="h-1 bg-muted rounded-full overflow-hidden">
            <div 
              className="h-full bg-green-500 rounded-full transition-all duration-[2000ms] ease-linear"
              style={{ width: stage >= 3 ? '100%' : '0%' }}
            />
          </div>
          <p className="text-xs text-muted-foreground mt-2">Redirecionando...</p>
        </div>
      </div>
    </div>
  );
}
